// extracted by mini-css-extract-plugin
module.exports = {"layoutLoaderContainer":"LayoutLoader__layoutLoaderContainer--1FI","layoutLoaderText":"LayoutLoader__layoutLoaderText--1JI"};